// Normalizes a picked date to the start (00:00) or end (23:59:59.999) of that day and shifts it by the
// local timezone offset, so the backend compares against the intended calendar day regardless of
// timezone. Used for building date-range filter bounds.
export function toDayBoundaryIso(date: Date, endOfDay: boolean): string {
  const boundary = endOfDay
    ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999)
    : new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  return new Date(boundary.getTime() - boundary.getTimezoneOffset() * 60000).toISOString();
}

export function convertStringToDate(dateString: string | Date){
  if(dateString != null || dateString == ''){
    return new Date(dateString);
  }
  return null;
}

export function convertDatesInEntity(entity: any, withOutTimezone: boolean = false): any {
  const entityCopy = { ...entity };
  for (const key of Object.keys(entityCopy)) {
      if (entityCopy[key] && Date.parse(entityCopy[key])) {
          entityCopy[key] = new Date(entityCopy[key]);

          if(withOutTimezone){
            entityCopy[key].setHours(0, 0, 0, 0);
            var timeOffsetInMS:number = entityCopy[key].getTimezoneOffset() * 60000;
            entityCopy[key].setTime(entityCopy[key].getTime() + timeOffsetInMS);
          }
      }
  }
  return entityCopy;
}

export function calcDateFromWeeks(date: Date, weeks: number): Date {
  return new Date(date.getTime() + weeks * 7 * 24 * 60 * 60 * 1000);
}

export function getCalendarWeekFromDate(date: Date): number{
   // Copying date so don't modify original
   date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
   // Set to nearest Thursday: current date + 4 - current day number
   // Make Sunday's day number 7
   date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
   // Get first day of year
   const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
   // Calculate full weeks to nearest Thursday
   const weekNo = Math.ceil(( (date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
   // Return array of year and week number
   return weekNo;
}

export function calcDateFromMonths(date: Date, months: number): Date {
  // is inaccurate
  // return new Date(date.getTime() + months * 30 * 24 * 60 * 60 * 1000);

  // chages the orinial passed in date ref
  // return new Date(date.setMonth(date.getMonth() + months));

  // A returns the value of the expression, here the return value of date.setMonth() as number
  // A: return date.setMonth(date.getMonth() + months);

  // So B returns the altered date
  // B: date.setMonth(date.getMonth() + months);
  // B: return date;

  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
}

// export const Quaters = [
//   {
//     from: '01/01/2022',
//     to: '31/03/2022',
//     name: 'Q1',
//     id: 1,
//   },
//   {
//     from: '01/04/2022',
//     to: '30/06/2022',
//     name: 'Q2',
//     id: 2,
//   },
//   {
//     from: '01/07/2022',
//     to: '30/09/2022',
//     name: 'Q3',
//     id: 3,
//   },
//   {
//     from: '01/10/2022',
//     to: '31/12/2022',
//     name: 'Q4',
//     id: 4,
//   }
// ];

// improve: could solve this with currying
export function getQuater(date: Date): {
  from: Date;
  to: Date;
  name: string;
  id: number;
} {
  const quaters = [
    {
      dayFrom: 1,
      monthFrom: 0,
      dayTo: 31,
      monthTo: 2,
      name: "Q1",
      id: 1,
    },
    {
      dayFrom: 1,
      monthFrom: 3,
      dayTo: 30,
      monthTo: 5,
      name: "Q2",
      id: 2,
    },
    {
      dayFrom: 1,
      monthFrom: 6,
      dayTo: 30,
      monthTo: 8,
      name: "Q3",
      id: 3,
    },
    {
      dayFrom: 1,
      monthFrom: 9,
      dayTo: 31,
      monthTo: 11,
      name: "Q4",
      id: 4,
    },
  ];

  const quater = quaters.find(
    (q) => q.id === Math.floor(date.getMonth() / 3 + 1)
  );

  return {
    from: new Date(date.getFullYear(), quater.monthFrom, quater.dayFrom),
    to: new Date(date.getFullYear(), quater.monthTo, quater.dayTo),
    name: quater.name,
    id: quater.id,
  };

  
}

export function getSecondsSinceStartOfDay(date: Date) {
  const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Start of the day (midnight)
  const diff = date.getTime() - startOfDay.getTime(); // Difference in milliseconds
  return Math.floor(diff / 1000); // Convert milliseconds to seconds
}

export function firstDayofMonth(date: Date = new Date()) : Date{
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function getLastDayOfMonth(date: Date = new Date()): Date {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function isToday(date: Date): boolean {
  const d = new Date(date);
  const now = new Date();
  return d.getFullYear() === now.getFullYear()
      && d.getMonth()    === now.getMonth()
      && d.getDate()     === now.getDate();
}

export function isPastDay(date: Date): boolean {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d.getTime() < today.getTime();
}

export function dueDateClass(dueDate: Date | null | undefined): string {
  if (!dueDate) return '';
  if (isPastDay(dueDate)) return 'error';
  if (isToday(dueDate)) return 'warning';
  return '';
}